// components/dashboard/ActivityTimeline.tsx
"use client";

import {
  ShoppingCart,
  CreditCard,
  Package,
  Headphones,
  LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ICON_MAP: Record<string, LucideIcon> = {
  ShoppingCart,
  CreditCard,
  Package,
  Headphones,
};

interface ActivityTimelineProps {
  activities: any[];
}

export function ActivityTimeline({ activities }: ActivityTimelineProps) {
  return (
    <div className="materio-card h-full flex flex-col">
      <div className="p-5 pb-2">
        <h3 className="text-base font-bold text-foreground">فعالیت‌های اخیر</h3>
        <p className="text-xs text-muted-foreground mt-1">آخرین رویدادهای فروشگاه</p>
      </div>
      <div className="p-5 pt-3 flex-1">
        <div className="space-y-0">
          {activities.map((activity, index) => {
            const Icon = ICON_MAP[activity.icon];
            const isLast = index === activities.length - 1;
            return (
              <div key={activity.id} className="flex gap-3">
                <div className="flex flex-col items-center">
                  <div
                    className={cn(
                      "w-9 h-9 rounded-xl flex items-center justify-center shrink-0 shadow-sm",
                      activity.bgColor
                    )}
                  >
                    <Icon className={cn("h-4 w-4", activity.color)} strokeWidth={2.5} />
                  </div>
                  {!isLast && <div className="w-0.5 flex-1 bg-border my-1.5" />}
                </div>
                <div className={cn("flex-1 pb-4", isLast && "pb-0")}>
                  <p className="text-sm font-bold leading-tight">{activity.title}</p>
                  <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                    {activity.description}
                  </p>
                  <p className="text-[10px] text-muted-foreground/70 mt-1.5 font-medium">
                    {activity.time}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}